// A weekly-reflection counterpart to `morningQuestion()` in the API
// (`packages/api/src/today.ts`) — same rotating-array shape, but there is no
// backend field for it (confirmed: no stored or computed weekly prompt
// anywhere in the API or the MCP tool, which emits `values_with_nothing_live`
// as raw data, not a phrased line). Computed client-side since this session
// changes no backend contract; folds into `today.ts` if a server-side one is
// ever wanted.

const PROMPTS = [
  "What did the week actually go to, against what you say matters?",
  "What would you protect first if next week were half as long?",
  "Where did the plan bend, and was that the week or was that you?",
  "What's been sitting a while because it's easy to postpone, not because it's wrong?",
  "What went well enough that you almost didn't notice it?",
  "What are you carrying that isn't actually yours to carry?",
  "If a value has nothing serving it, what is that actually telling you?",
  "What's the smallest true thing you could say about this week?",
];

/** Same index for the whole week, rotating week to week — no comparison implied, just variety. */
export function weeklyPrompt(dateISO: string): string {
  const days = Math.floor(new Date(`${dateISO}T00:00:00Z`).getTime() / 86_400_000);
  const week = Math.floor(days / 7);
  return PROMPTS[((week % PROMPTS.length) + PROMPTS.length) % PROMPTS.length];
}
